const ACCESS_TOKEN_KEY = 'bid:aibiaoshu:auth:access_token';
const AUTH_INVALIDATED_EVENT = 'bid:aibiaoshu:auth:invalidated';

const getSessionStorage = (): Storage | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const getAccessToken = (): string | null =>
  getSessionStorage()?.getItem(ACCESS_TOKEN_KEY) || null;

export const setAccessToken = (token: string): void => {
  getSessionStorage()?.setItem(ACCESS_TOKEN_KEY, token);
};

export const clearAccessToken = (): void => {
  getSessionStorage()?.removeItem(ACCESS_TOKEN_KEY);
};

export const invalidateAuthSession = (): void => {
  clearAccessToken();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_INVALIDATED_EVENT));
  }
};

export const subscribeAuthInvalidated = (
  listener: () => void
): (() => void) => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  window.addEventListener(AUTH_INVALIDATED_EVENT, listener);
  return () => window.removeEventListener(AUTH_INVALIDATED_EVENT, listener);
};

export const authStorageKeys = {
  accessToken: ACCESS_TOKEN_KEY,
} as const;
